<header
  class="app-header sticky top-0 z-50 w-full border-b border-outline-variant/50 bg-background/80 shadow-xs backdrop-blur-xl supports-[backdrop-filter]:bg-background/60"
>
  <div class="container flex justify-between h-16 items-center">
    <a
      routerLink="/"
      class="flex h-16 items-center justify-self-start outline-none pl-3 lg:pl-0"
      aria-label="Basilon home"
    >
      <img
        ngSrc="assets/images/brand/basilon-logo.webp"
        width="147"
        height="64"
        alt="Basilon"
        class="h-[2.667rem] w-auto lg:h-16"
        priority
      />
    </a>

    <div class="flex items-center gap-2 justify-self-end sm:gap-3">
      <div class="hidden min-w-0 justify-self-start lg:block pr-3">
        @if (!showMenu()) {
          <nav class="flex items-center gap-6 text-sm" aria-label="Primary navigation">
            @if (isHomeAndUnauthenticated()) {
              @for (item of homeItems(); track item.link) {
                <a [href]="item.link" class="nav-button">
                  {{ item.label }}
                </a>
              }
            } @else {
              @for (item of navItems(); track item.link) {
                @if (item.link === '/pricing' || authFacade.isAuthenticated()) {
                  <a [routerLink]="item.link" class="nav-button">
                    {{ item.label }}
                  </a>
                }
              }
            }
          </nav>
        }
      </div>

      <ng-template #navNewProjectBtn>
        @if (authFacade.isAuthenticated()) {
          <button
            matButton="filled"
            class="btn-xs btn-gradient hidden whitespace-nowrap sm:inline-flex"
            (click)="openCreateProjectDialog()"
          >
            <mat-icon>add</mat-icon>
            New Project
          </button>
        }
      </ng-template>

      @if (!showMenu()) {
        <ng-container *ngTemplateOutlet="navNewProjectBtn"></ng-container>
      }

      <!-- <button
        matIconButton
        class="dark-light-mode-btn btn-sm"
        [attr.data-theme]="currentTheme()"
        aria-label="Change theme"
        (click)="cycleTheme()"
      >
        <mat-icon class="theme-mode-icon icon-auto">contrast</mat-icon>
        <mat-icon class="theme-mode-icon icon-light">light_mode</mat-icon>
        <mat-icon class="theme-mode-icon icon-dark">dark_mode</mat-icon>
      </button> -->

      @if (authFacade.isAuthenticated()) {
        <button
          matIconButton
          class="btn-sm"
          [matMenuTriggerFor]="notificationsMenu"
          aria-label="Notifications"
        >
          @if (notifications.length) {
            <mat-icon
              matBadge="{{ notifications.length }}"
              matBadgeColor="warn"
              aria-hidden="false"
            >
              notifications
            </mat-icon>
          } @else {
            <mat-icon>notifications</mat-icon>
          }
        </button>

        <button
          matIconButton
          [matMenuTriggerFor]="accountMenu"
          class="btn-sm"
          aria-label="Account menu"
        >
          <mat-icon>account_circle</mat-icon>
        </button>
      } @else {
        <a [routerLink]="signInRoute" matButton class="btn-xs whitespace-nowrap">Sign in</a>

        @if (isHomeAndUnauthenticated()) {
          <a matButton="filled" class="btn-xs whitespace-nowrap" [routerLink]="signUpRoute">
            Start a project
          </a>
        }
      }

      <button
        matIconButton
        [matMenuTriggerFor]="navMenu"
        class="btn-sm lg:hidden"
        aria-label="Open navigation menu"
      >
        <mat-icon>menu</mat-icon>
      </button>
    </div>

    <mat-menu #navMenu="matMenu" class="lg:hidden">
      @if (showMenu()) {
        @if (authFacade.isAuthenticated()) {
          <div class="mx-2 mt-1">
            <ng-container *ngTemplateOutlet="navNewProjectBtn"></ng-container>
          </div>
          <mat-divider class="mb-2 mt-3"></mat-divider>
        }
        @for (item of navItems(); track item.link) {
          @if (item.link === '/pricing' || authFacade.isAuthenticated()) {
            <a mat-menu-item [routerLink]="item.link">
              {{ item.label }}
            </a>
          }
        }
      }
    </mat-menu>

    <mat-menu #accountMenu="matMenu">
      @for (item of accountItems(); track item.tab) {
        <a mat-menu-item routerLink="/account" [queryParams]="{ tab: item.tab }">
          <mat-icon>{{ item.iconName }}</mat-icon>
          {{ item.label }}
        </a>
      }
      <mat-divider class="my-2"></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        Log Out
      </button>
    </mat-menu>

    <mat-menu #notificationsMenu="matMenu" class="notifications-menu">
      <div
        class="w-[min(22rem,calc(100vw-2rem))] max-w-full overflow-x-hidden bg-white p-2"
        (click)="$event.stopPropagation()"
      >
        <div class="flex items-center justify-between px-2 pb-2 pt-1">
          <span class="text-sm font-semibold">Notifications</span>
          <span class="text-xs text-neutral-40">{{ notifications.length }} new</span>
        </div>

        <div class="space-y-1">
          @for (notification of notifications; track notification.title) {
            <div class="rounded-lg p-2 transition-colors hover:bg-surface-container-high">
              <div class="flex gap-2">
                <mat-icon class="mt-0.5 shrink-0 text-primary" aria-hidden="true">
                  {{
                    notification.type === 'SUCCESS'
                      ? 'check_circle'
                      : notification.type === 'WARNING'
                        ? 'warning'
                        : 'info'
                  }}
                </mat-icon>
                <div class="min-w-0">
                  <p class="text-sm font-medium leading-5">{{ notification.title }}</p>
                  <p class="mt-0.5 text-xs leading-4 text-neutral-40">
                    {{ notification.description }}
                  </p>
                  <button
                    matButton="text"
                    type="button"
                    class="mt-1 !min-h-0 px-2 text-xs btn-xs"
                    (click)="openNotification(notification)"
                  >
                    {{ notification.action }}
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </mat-menu>
  </div>
</header>
